<template>
    <ai-tree-virtual ref="eoBasketTreeListRef" :meta="meta">
        <template #toolbarItems>
            <dx-item location="after" name="restore" widget="dxButton">
                <dx-button
                    class="ai-button-base"
                    hint="Восстановить"
                    icon="/infoenergo/assets/ai-revert-base.svg"
                    @click="onSaveClick(meta.args.save.restore)"
                />
                <dx-button
                    class="ai-button-base"
                    hint="Удалить"
                    icon="/infoenergo/assets/ai-delete-base.svg"
                    @click="onSaveClick(meta.args.save.drop)"
                />
            </dx-item>
        </template>
    </ai-tree-virtual>
</template>
<script setup>
import { ref } from 'vue';
import AiTreeVirtual from '@/components/ai-tree-virtual/ai-tree-virtual.vue';
import { DxItem } from 'devextreme-vue/data-grid';
import { DxButton } from 'devextreme-vue';
import { commitDataChanges } from '@/service/meta-service';
import { dxUiNotify } from '@/utils/dx-helper';

const columns = [
    {
        dataField: 'name',
        caption: 'Диспетчерский №',
        allowFiltering: true,
        cellTemplate: 'firstColumnCellTemplate',
        svg: 'asset_svg',
    },
    { dataField: 'kindname', caption: 'Вид оборудования', allowFiltering: true, width: 80 },
    { dataField: 'setiname_str', caption: 'Зона филиала', allowFiltering: true, width: 100 },
    { dataField: 'bname', caption: 'Балансовая принадлежность', allowFiltering: true, width: 300 },
    { dataField: 'ename', caption: 'Эксплуатационная ответственность', allowFiltering: true, width: 300 },
    { dataField: 'imported', caption: 'Импортирован', allowFiltering: true, width: 80 },
    { dataField: 'distrobj_kindname', caption: 'Вид объекта', allowFiltering: true, width: 80 },
    { dataField: 'distrobjname', caption: 'Объект', allowFiltering: true, width: 100 },
    { dataField: 'bname_eo', caption: 'Балансовая принадлежность объекта', allowFiltering: true, width: 300 },
    { dataField: 'ename_eo', caption: 'Эксплуатационная ответственность объекта', allowFiltering: true, width: 300 },
    { dataField: 'puser', caption: 'Пользователь', allowFiltering: true },
    { dataField: 'cantdel', caption: 'Нельзя удалять', allowFiltering: true },
];
const meta = {
    meta_args: {
        schema: 'e_grid',
        table: 'hv_eobasket_new',
        fields: columns.map(c => c.dataField),
    },
    api: {
        select: 'e-grid./eobasket/data/get',
        save: 'e-grid./eobasket/data/set',
    },
    selection: 'multiple',
    id: 'eobj_id',
    id_parent: 'parent_id',
    pathField: 'path',
    limit: 50,
    columns: columns,
    args: {
        save: {
            restore: {
                meta_args: {
                    update: 'e_grid.hf_eobject_restore',
                },
            },
            drop: {
                meta_args: {
                    update: 'e_grid.hf_eobject_drop',
                },
            },
        },
    },
};
const eoBasketTreeListRef = ref();
const onSaveClick = async event => {
    const listInstance = eoBasketTreeListRef.value.listRef.instance;
    const processedData = {
        insertDataArgs: [],
        updateDataArgs: listInstance.getSelectedRowKeys().map(key => listInstance.getNodeByKey(key).data),
        deleteDataArgs: [],
    };
    if (processedData.updateDataArgs.length > 0) {
        const { errors } = await commitDataChanges(meta.api.save, processedData, event);
        //Про валидацию пока забыли
        if (errors?.length > 0) {
            dxUiNotify(`Ошибка базы данных: ${errors.map(error => error.message).join('\n')}`, 'error');
        } else {
            dxUiNotify('Изменения данных прошли успешно', 'success');
            eoBasketTreeListRef.value.refresh();
        }
    }
};
</script>
<script>
export default {
    name: 'view-hv-eobasket-new',
};
</script>
